import { ResponseTypes } from "../../services/APIService";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const getToken = (): string => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }
    return token
}

export type APIResponseAcknowledgement = {
    clientId: string;
    type: string;
    status: string;
    ewId: string;
    ewPcode: string;
    clientGn: string;
    timestamp: string;
    lon: number;
    lat: number;
    name: string;
}

export const APIGetAllAcknowledgments = async (): Promise<{status: boolean, data: APIResponseAcknowledgement[], message: string}> => {
    const URL: string = `${BASE_URL}/acknowledge/api/v1/get_all_acknowledges`
    const HEADER: RequestInit = {
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
        }
    }

    try
    {
        const response = await fetch(URL, HEADER);
        const responseData = await response.json();
        const data = responseData as ResponseTypes;

        if (response.ok)
        {
            return {status: true, data: data.data as APIResponseAcknowledgement[], message: data.message}
        }
        else
        {
            return {status: false, data: [], message: data.message}
        }
    }
    catch (error)
    {
        console.error("Error while getting all acknowledgments with error [ ", error, "]")
        return {status: false, data: [], message: "error while loading acknowledgment data"}
    }
}